import { isNil } from 'ramda';
import { FeeRequest } from '~client/model/admin/fee-request';
import { FeeTranslationRequestItem } from '~client/model/admin/fee-translation-request-item';
import {
  ApplicationLevel,
  BreakdownDisplayOption,
  Reason,
  ResponsibilityType,
  SubReason,
  ValueType,
} from '~client/model/fee-breakdown-item';
import { MarketplaceType } from '~client/model/marketplace-type';

interface FeeData {
  applicationLevel: string;
  breakdownDisplayOption: string;
  feeName: string;
  responsibilityType: string;
  valueType: string;
  applyOrder: number;
  reason?: string;
  subReason?: string;
  translations?: FeeTranslationRequestItem[];
}

export const validFee = (value: number): boolean => !isNil(value) && value > 0;

export const addFee = (
  feeList: FeeRequest[],
  value: number,
  resaleValue: number,
  includedInBase: boolean,
  feeData: FeeData,
  feeNameLong: string = feeData.feeName,
): void => {
  const {
    applicationLevel,
    breakdownDisplayOption,
    feeName,
    responsibilityType,
    valueType,
    applyOrder,
    reason,
    subReason,
    translations,
  } = feeData as {
    applicationLevel: ApplicationLevel;
    breakdownDisplayOption: BreakdownDisplayOption;
    feeName: string;
    responsibilityType: ResponsibilityType;
    valueType: ValueType;
    applyOrder: number;
    reason: Reason;
    subReason: SubReason;
    translations: FeeTranslationRequestItem[];
  };

  // Repeat every fee separately for resale, except any included fees. Those
  // have to apply just to the fee total rather than the base amount.
  if (validFee(resaleValue)) {
    feeList.push({
      applicationLevel: includedInBase ? ApplicationLevel.PREVIOUS_FEE : applicationLevel,
      breakdownDisplayOption: includedInBase
        ? BreakdownDisplayOption.EMAIL
        : breakdownDisplayOption,
      feeName,
      feeNameLong,
      responsibilityType,
      marketplaceType: MarketplaceType.SECONDARY_EXCHANGE,
      value: resaleValue,
      valueType,
      applyOrder,
      includedInBase,
      reason,
      subReason,
      translations,
    });
  }

  if (validFee(value) && responsibilityType === ResponsibilityType.BUYER) {
    feeList.push({
      applicationLevel,
      breakdownDisplayOption,
      feeName,
      feeNameLong,
      responsibilityType,
      value,
      valueType,
      applyOrder,
      includedInBase,
      reason,
      subReason,
      translations,
    });
  }
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-fee-details/add-fee.helper.ts